var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mainConfig.enableFilters)?_c('lot-filter',{on:{"menuClose":_vm.onClose,"clearFilters":_vm.clearFilters,"applyFilters":_vm.applyFilters}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }